var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComplementaryDataWrapper, Subtitle, Title } from './subcomponents';
export var ComplementaryData = function (_a) {
    var currentPointsValue = _a.currentPointsValue, currentPointsText = _a.currentPointsText;
    return (_jsxs(ComplementaryDataWrapper, { children: [_jsx(Title, { children: currentPointsValue }), _jsx(Subtitle, __assign({ "data-cy": "wheel-chart-current-points" }, { children: currentPointsText }))] }));
};
export default ComplementaryData;
